export default {
  name: 'marking--docShipmentReport',
  urlParamName: 'marking--docShipmentReport',
};